'use client';

import type { Post } from '@routeroyal/theme-core';
import { AllysCTASection, AllysPostArticle } from '@routeroyal/theme-allys';

type Props = {
  article: Post;
  relatedArticles: Post[];
  locale: string;
  messages: Record<string, unknown>;
  basePath: string;
};

export function ArticleContentAllys({ 
  article, 
  relatedArticles, 
  locale,
  messages,
  basePath
}: Props) {
  const handleShare = (platform: 'twitter' | 'facebook' | 'linkedin' | 'copy') => {
    const url = window.location.href;
    const text = article.title;

    let shareUrl = '';

    switch (platform) {
      case 'twitter':
        shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`;
        break;
      case 'facebook':
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
        break;
      case 'linkedin':
        shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
        break;
      case 'copy':
        navigator.clipboard.writeText(url);
        return;
    }

    if (shareUrl) {
      window.open(shareUrl, '_blank', 'width=600,height=400');
    }
  };

  // Get localized messages for the article component
  const articleMessages = (messages?.blog || messages?.posts || {}) as Record<string, string>;

  return (
    <>
      {/* Main Content */}
      <main className="min-h-screen bg-white pt-24 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <AllysPostArticle
            post={article}
            relatedPosts={relatedArticles}
            onShare={handleShare}
            locale={locale}
            basePath="/news"
            showShareButtons={true}
            showAuthorBio={true}
            showRelatedPosts={relatedArticles.length > 0}
            messages={articleMessages}
          />
        </div>
      </main>

      {/* CTA Section */}
      <AllysCTASection
        maskBackgroundImages={[
          'https://media.routeroyal.com/GdS1cGKCX71Gk6hIKB_5c2EQds5fD3AfXKQLzIkMugA/raw:1/czM6Ly9jb2xsYXBzaWJsZS1wdXJzZS1kbW9rLWRubDd4cy9yb3V0ZXJveWFsL3JveWFsZS9zdGF0aWMvY2MwOTUxYzQ4ZjdiYmYwMWMzYWM5MjdlNjcyYzEyYTk4NGMwYWRjMDhlMmU1ZWYzMjUyYzA4ZDVmNzY0YzhjYy53ZWJw.webp',
          'https://media.routeroyal.com/V_D1ux5wZnx9Uzdbflksb9EGtg1jQ5TwmMVJaVlrwKk/raw:1/czM6Ly9jb2xsYXBzaWJsZS1wdXJzZS1kbW9rLWRubDd4cy9yb3V0ZXJveWFsL3JveWFsZS9zdGF0aWMvMDE1NWIyNjcyOWMyNzZiM2ViZTkwNWIxMmUwNTg0NTUzNWQwODE0OWVhYzYxNGI2ZDcyNzY3NjZjNDg4MmZjMy53ZWJw.webp',
          'https://media.routeroyal.com/e1fB7NC6JfKFzu-rxSFSmHcLU0UzUdDVDF7aheqyTjs/raw:1/czM6Ly9jb2xsYXBzaWJsZS1wdXJzZS1kbW9rLWRubDd4cy9yb3V0ZXJveWFsL3JveWFsZS9zdGF0aWMvZDU4ZDIzYWFkZDM2NjlkYzVkMzg0MmM3ZjUwY2M0Y2RhMDMxZmZlYzIwN2Q4OTJkMzI2ZjM1ZDcyZjVjNGYxYy53ZWJw.webp',
        ]}
        primaryButton={{
          text: 'View Properties',
          href: `${basePath}/properties`,
          variant: 'primary',
        }}
        locale={locale as 'en' | 'es' | 'fr'}
      />
    </>
  );
}
